.wrap {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  isolation: isolate;
}

/* Blue grid underlay */
.grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(to right, rgba(122, 167, 255, 0.10) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(122, 167, 255, 0.10) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 80%);
  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 80%);
  opacity: 0.8;
}

[data-theme='light'] .grid {
  background-image:
    linear-gradient(to right, rgba(40, 90, 200, 0.12) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(40, 90, 200, 0.12) 1px, transparent 1px);
}

/* Shooting stars layer */
.star {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 9999px;
  background: var(--star-color, #7aa7ff);
  opacity: 0;
  box-shadow:
    0 0 8px var(--star-color, #7aa7ff),
    0 0 18px color-mix(in srgb, var(--star-color, #7aa7ff) 70%, transparent);

  animation-name: shootGrid;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.35, 0.05, 0.65, 1);
  animation-fill-mode: both;
  will-change: transform, opacity;
}

.star::after {
  content: '';
  position: absolute;
  background: linear-gradient(
    var(--trail-gradient-direction, to top),
    var(--star-color, #7aa7ff),
    color-mix(in srgb, var(--star-color, #7aa7ff) 35%, transparent) 45%,
    transparent 100%
  );
}

/* down */
.star[style*='--direction: down']::after {
  left: 50%;
  bottom: 100%;
  width: 1px;
  height: var(--trail-length, 120px);
  transform: translateX(-50%);
  --trail-gradient-direction: to top;
}

/* up */
.star[style*='--direction: up']::after {
  left: 50%;
  top: 100%;
  width: 1px;
  height: var(--trail-length, 120px);
  transform: translateX(-50%);
  --trail-gradient-direction: to bottom;
}

/* right */
.star[style*='--direction: right']::after {
  top: 50%;
  right: 100%;
  width: var(--trail-length, 120px);
  height: 1px;
  transform: translateY(-50%);
  --trail-gradient-direction: to left;
}

/* left */
.star[style*='--direction: left']::after {
  top: 50%;
  left: 100%;
  width: var(--trail-length, 120px);
  height: 1px;
  transform: translateY(-50%);
  --trail-gradient-direction: to right;
}

@keyframes shootGrid {
  0% {
    opacity: 0;
    transform: translate3d(var(--from-x), var(--from-y), 0);
  }

  8% {
    opacity: 1;
  }

  70% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate3d(var(--to-x), var(--to-y), 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .star {
    animation: none;
    opacity: 0;
  }
}
